import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  configCkeditor = {
    allowedContent: true,
    autoParagraph : false,
    fillEmptyBlocks : false,
    forcePasteAsPlainText : true
  };

  constructor(
    private domSanitizer: DomSanitizer
  ){}

  getSecurityTrustURL(response:any){
    let objectURL = URL.createObjectURL(response);
    return this.domSanitizer.bypassSecurityTrustUrl(objectURL);
  }

  getSecurityTrustResourceUrl(response){
    let objectURL = URL.createObjectURL(response);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(objectURL);
  }

  resetCkeditoIframe(){
    for(let objName in window["CKEDITOR"].instances){
      console.log(objName);
      window["CKEDITOR"].instances[objName].destroy()
    }
  }

  isValidImage(file: Blob) {
    const acceptedImageTypes = ['image/bmp', 'image/jpeg', 'image/png'];
    return file && acceptedImageTypes.indexOf(file.type);
  }

  getImageExtension(file: Blob) {
    if(file == null || file.type == null)
      return null;

    const mapping = {
      'image/bmp': 'bmp',
      'image/jpeg': 'jpg',
      'image/png': 'png'
    };

    return mapping[file.type];
  }
  
  getFolderNameRegex() {
    return '^[A-Za-z0-9-_!$&*()\',; ]+$';
  }

  getRandomInt(min, max) {
    return Math.floor(this.cryptoRandom() * (max - min + 1) + min)
  }

  cryptoRandom() {
    let crypto = window.crypto;
    try {
      let cryptoRandoms, cryptoRandomSlices = [], cryptoRandom;
      cryptoRandom = "." + cryptoRandomSlices.join("");
      while (cryptoRandom.length < 30) {
        cryptoRandoms = crypto.getRandomValues(new Uint32Array(5));
        for (let c of cryptoRandoms) {
          let cryptoRandomSlice = c.toString().slice(1, -1);
          if (cryptoRandomSlice.length > 0) cryptoRandomSlices[cryptoRandomSlices.length] = cryptoRandomSlice;
        }
      }
      return Number(cryptoRandom);
    } catch (e) {
      return 0;
    }
  };


  getConfigCkeditor(){
    return this.configCkeditor;
  }
}
